




































































































































































































































































































































































































































































































































































































































































































/* eslint-disable import/extensions */
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { round, shuffle } from 'lodash-es';
import { differenceInMonths, format } from 'date-fns';
import Loader from '~/components/shared/Loader.vue';
import Logo from '~/components/shared/Logo.vue';
import formatScore from '~/utils/format-score';
import share from '~/utils/share';
import meta from '~/meta';
import { responseError } from '~/utils/response-error';
import LibraryIcon from '~/components/shared/LibraryIcon.vue';
import { getUTCDate } from '~/utils/date';
import CompanyCard from '~/components/profile/WorkExperience/CompanyCard.vue';
import copyToClipboard from '~/utils/copy-to-clipboard';
import notification from '~/ui/utils/notification';
import YearShare from '~/components/shared/YearShare.vue';

const daysShort = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
const daysLong = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const monthsLong = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/* eslint-disable */
const avatars = {
  argentina: require('../../../../assets/2020/avatars/argentina.json'),
  brazil: require('../../../../assets/2020/avatars/brazil.json'),
  chile: require('../../../../assets/2020/avatars/chile.json'),
  colombia: require('../../../../assets/2020/avatars/colombia.json'),
  france: require('../../../../assets/2020/avatars/france.json'),
  germany: require('../../../../assets/2020/avatars/germany.json'),
  hungary: require('../../../../assets/2020/avatars/hungary.json'),
  india: require('../../../../assets/2020/avatars/india.json'),
  italy: require('../../../../assets/2020/avatars/italy.json'),
  netherlands: require('../../../../assets/2020/avatars/netherlands.json'),
  poland: require('../../../../assets/2020/avatars/poland.json'),
  russia: require('../../../../assets/2020/avatars/russia.json'),
  spain: require('../../../../assets/2020/avatars/spain.json'),
  turkey: require('../../../../assets/2020/avatars/turkey.json'),
  ukraine: require('../../../../assets/2020/avatars/ukraine.json'),
  'united kingdom': require('../../../../assets/2020/avatars/united_kingdom.json'),
  'united states': require('../../../../assets/2020/avatars/united_states.json'),
};
/* eslint-enable  */

const ScrollIcon = {
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
  render(): any {
    // @ts-ignore
    const h = this.$createElement;
    return h(
      'svg',
      {
        attrs: {
          width: 20,
          height: 28,
          viewBox: '0 0 20 28',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg',
        },
      },
      [
        h('path', {
          attrs: {
            d:
              'M10.013 23.5235L5.10376 18.3338L6.6929 16.8305L10.0088 20.3358L13.305 16.8326L14.8982 18.3316L10.013 23.5235ZM19.0781 21.4375V6.5625C19.0781 2.94394 16.1342 0 12.5156 0H7.48438C3.86581 0 0.921875 2.94394 0.921875 6.5625V21.4375C0.921875 25.0561 3.86581 28 7.48438 28H12.5156C16.1342 28 19.0781 25.0561 19.0781 21.4375ZM12.5156 2.1875C14.9281 2.1875 16.8906 4.15005 16.8906 6.5625V21.4375C16.8906 23.8499 14.9281 25.8125 12.5156 25.8125H7.48438C5.07193 25.8125 3.10938 23.8499 3.10938 21.4375V6.5625C3.10938 4.15005 5.07193 2.1875 7.48438 2.1875H12.5156ZM10 4.42969C9.39587 4.42969 8.90625 4.91931 8.90625 5.52344C8.90625 6.12756 9.39587 6.61719 10 6.61719C10.6041 6.61719 11.0938 6.12756 11.0938 5.52344C11.0938 4.91931 10.6041 4.42969 10 4.42969ZM10 8.80469C9.39587 8.80469 8.90625 9.29431 8.90625 9.89844C8.90625 10.5026 9.39587 10.9922 10 10.9922C10.6041 10.9922 11.0938 10.5026 11.0938 9.89844C11.0938 9.29431 10.6041 8.80469 10 8.80469ZM10 13.1797C9.39587 13.1797 8.90625 13.6693 8.90625 14.2734C8.90625 14.8776 9.39587 15.3672 10 15.3672C10.6041 15.3672 11.0938 14.8776 11.0938 14.2734C11.0938 13.6693 10.6041 13.1797 10 13.1797Z',
            // @ts-ignore
            fill: this.color,
          },
        }),
      ],
    );
  },
};

@Component({
  components: {
    Loader,
    Logo,
    LibraryIcon,
    ScrollIcon,
    CompanyCard,
    YearShare,
  },
  layout: 'empty',
})
export default class extends Vue {
  errorMessage = '';
  swiper: any = undefined;
  userData: any;
  activeSections: string[] = [];
  sectionAnimationProgress: any = {};
  hasActivityChart = true;
  totalActivities = 0;
  languageColors = ['#1557FF', '#50B0BA', '#512DA8', '#1E9700', '#EE3535'];
  thanks = shuffle([
    'thanks',
    'aitäh',
    'köszönjük',
    'merci',
    'arigato',
    'dhanyawaad',
    'gracias',
    'danke',
    'shukran',
    'takk',
    'paldies',
    'mulțumesc',
    'teşekkürler',
    'hvala',
    'σας ευχαριστώ',
    'спасибо',
    'grazie',
    'ありがとう',
    'obrigado',
    'kiitos',
    '谢谢',
  ]).map((thank) => {
    const fontSize = 14 + Math.floor(Math.random() * 24);
    const fontWeight = [100, 300, 400, 600, 700, 800][Math.floor(Math.random() * 4)];
    return {
      text: thank,
      style: {
        fontSize: `${fontSize / 100}em`,
        fontWeight,
      },
    };
  });

  get username() {
    return this.userData ? this.userData.username || this.userData.user_name : '';
  }

  get mostActiveTime() {
    return (
      ['Night', 'Morning', 'Daytime', 'Evening'].indexOf(this.userData.most_active_day_part.most_active_day_part) + 1
    );
  }

  get mostActiveTimeLabel() {
    return this.userData.most_active_day_part.most_active_day_part;
  }

  get mostActiveDayLabel() {
    return this.userData.most_active_day.day;
  }

  get mostActiveDays() {
    const mostActive = daysLong.indexOf(this.userData.most_active_day.day) + 1;
    const daysData = [];
    const daysValues = (this.userData.most_active_day.commits_per_day || []).map(
      (item: any) => item.distinct_commit_count,
    );
    const max = Math.max(...daysValues, 0.0001);
    const days = [...daysShort];
    for (let i = 1; i <= 7; i += 1) {
      daysData.push({
        label: days[i - 1],
        value: (daysValues[i - 1] || 0) / max,
        isMostActive: i === mostActive,
      });
    }
    return daysData;
  }

  get mostActiveMonthLabel() {
    return this.userData.most_active_month.month;
  }

  get mostActiveMonths() {
    const mostActive = monthsLong.indexOf(this.userData.most_active_month.month) + 1;
    const monthsData = [];
    const monthsValues = (this.userData.most_active_month.monthly_commit_count || []).map(
      (item: any) => item.distinct_commit_count,
    );
    const max = Math.max(...monthsValues, 0.0001);
    const months = [...monthsShort];
    for (let i = 1; i <= 12; i += 1) {
      monthsData.push({
        label: months[i - 1],
        value: (monthsValues[i - 1] || 0) / max,
        isMostActive: i === mostActive,
      });
    }
    return monthsData;
  }

  get topLanguagesData() {
    return {
      data: this.userData.top_languages.top_5.map((l: any) => round(l.score_gain)),
      labels: this.userData.top_languages.top_5.map((l: any) => l.language),
      colors: [...this.languageColors],
    };
  }

  get topReposData() {
    return {
      data: this.userData.repo_score_gain.map((r: any) => round(r.score_change)),
      labels: this.userData.repo_score_gain.map((r: any) => r.repo_name),
      colors: [...this.languageColors],
    };
  }

  get selfImprovementData() {
    const colors = ['#DAEF5C', '#00B8A2', '#FFB300', '#42D2FF', '#fff'];
    const data = this.userData.top_languages.top_5.map((l: any) => {
      return {
        value: l.score_gain,
        label: l.language,
      };
    });

    const max = Math.max(...data.map((el: any) => el.value));
    data.forEach((el: any, index: any) => {
      el.color = colors[index];
      el.height = (el.value / max) * 70;
    });
    return data;
  }

  get hasPeopleSlide() {
    return (
      this.userData.total_score_gain &&
      this.userData.total_score_gain.personal_score_gain > this.userData.total_score_gain.score_thrs
    );
  }

  get avatarsData() {
    const country = this.userData.country.toLowerCase();
    // @ts-ignore
    const data = avatars[country];
    if (!data) return [];
    return Object.keys(data)
      .map((hash) => {
        const url = data[hash];
        if (!url) return undefined;
        return {
          isCurrent: hash === this.$route.params.userHash,
          url: url.indexOf('?') > 0 ? `${data[hash]}&s=100` : `${data[hash]}?s=100`,
        };
      })
      .filter((el) => !!el);
  }

  get certificates() {
    const formatDate = (date: any) => {
      let newDate;
      try {
        newDate = format(getUTCDate(date.replace(' ', 'T')), 'MMM yyyy');
      } catch (err) {
        newDate = date;
      }
      return newDate;
    };
    const certs = [...(this.userData.new_certificates || this.userData.new_education || [])];
    certs.forEach((cert: any) => {
      cert.dateString = formatDate(cert.date);
    });
    return certs;
  }

  get portfolios() {
    const portfolios = [...(this.userData.new_projects || [])];
    return portfolios.slice(0, 8);
  }

  get workExperience() {
    const we = (this.userData.new_jobs || [])[0];
    if (!we) return null;
    if (we.companylogourl) we.companyLogoURL = we.companylogourl;
    if (we.companyname) we.companyName = we.companyname;
    if (we.company) we.companyName = we.company;
    if (we.currentlyworkinghere) we.currentlyWorkingHere = we.currentlyworkinghere;
    if (we.enddate) {
      if (we.enddate.indexOf(' ') > 0) we.enddate = we.enddate.replace(' ', 'T');
      we.endDate = we.enddate;
    }
    if (we.highlightedtechnologies) we.highlightedTechnologies = we.highlightedtechnologies;
    if (we.othertechnologies) we.otherTechnologies = we.othertechnologies;
    if (we.startdate) {
      if (we.startdate.indexOf(' ') > 0) we.startdate = we.startdate.replace(' ', 'T');
      we.startDate = we.startdate;
      we.startDate = new Date(new Date(we.startDate).getTime() + 22 * 60 * 60 * 1000);
    }
    we.titles = [
      {
        ...we,
      },
    ];
    let totalMonths = 0;
    we.titles.forEach((title: any) => {
      const endDate = title.currentlyWorkingHere ? new Date() : new Date(title.endDate);
      totalMonths += differenceInMonths(endDate, new Date(title.startDate));
    });
    we.totalMonths = totalMonths;
    return we;
  }

  head() {
    return meta({
      title: `Year in Review 2020 - ${this.username}'s Edition`,
      description: 'Discover your own personalized stats with CodersRank.',
      image: `https://cr-ss-service.azurewebsites.net/api/ScreenShot?year-in-review=true&hash=${this.$route.params.userHash}`,
    });
  }

  async asyncData({ route, $sentry }: any) {
    let userData = {} as any;
    let errorMessage = '';
    try {
      const res = await axios.get(
        `${(axios.defaults as any).gatewayBase}/year-in-review/2020/${route.params.userHash}`,
      );
      userData = res.data.payload;
    } catch (err) {
      errorMessage = responseError(err);
      $sentry.captureException(err);
    }

    return {
      userData,
      errorMessage,
    };
  }

  async mounted() {
    if (!this.userData) {
      return;
    }

    if (window.customElements && !window.customElements.get('codersrank-activity')) {
      import(/* webpackChunkName: "codersrank-activity" */ '@codersrank/activity').then(
        ({ default: CodersRankActivity }) => {
          window.customElements.define('codersrank-activity', CodersRankActivity);
        },
      );
    }

    const [{ default: Swiper }] = await Promise.all([
      import(/* webpackChunkName: "swiper" */ 'swiper'),
      import(/* webpackChunkName: "swiper" */ 'swiper/css/swiper.css'),
    ]);

    this.$nextTick(() => {
      this.swiper = new Swiper({
        el: this.$el,
        direction: 'vertical',
        slidesPerView: 'auto',
        speed: 600,
        simulateTouch: false,
        parallax: true,
        mousewheel: {
          enabled: true,
          sensitivity: window.navigator.platform === 'Win32' || window.navigator.platform === 'Win64' ? 1.5 : 1,
        },
        keyboard: {
          enabled: true,
        },
        on: {
          transitionEnd: () => {
            if (!this.swiper) return;
            const sectionId = this.swiper.slides.eq(this.swiper.activeIndex).attr('id');
            if (sectionId) this.activateSection(sectionId);
          },
        },
      });
    });
  }

  activateSection(section: string) {
    if (this.activeSections.indexOf(section) >= 0) return;
    this.activeSections.push(section);
    // @ts-ignore
    this.$el.querySelector(`#${section}`).classList.add('year-2020-slide-activated');
    this.$set(this.sectionAnimationProgress, section, 0);
    const startTime = Date.now();
    const duration = 800;
    const render = () => {
      const timeDiff = Date.now() - startTime;
      if (timeDiff >= duration) {
        this.$set(this.sectionAnimationProgress, section, 1);
        return;
      }
      this.$set(this.sectionAnimationProgress, section, timeDiff / duration);
      requestAnimationFrame(render);
    };
    requestAnimationFrame(render);
  }

  animatableNumber(section: string, target: number) {
    if (this.activeSections.indexOf(section) < 0) return 0;
    return Math.round(this.sectionAnimationProgress[section] * target);
  }

  mostActiveTimeHourHeight(hour: any) {
    const hoursData = (this.userData.most_active_day_part.hourly_commits || []).map(
      (item: any) => item.distinct_commit_count,
    );
    const max = Math.max(...hoursData, 0.001);
    const value = (hoursData[hour - 1] || 0) / max;
    return value * 100;
  }

  onActivityData(e: any) {
    this.totalActivities = e.detail.total;
    if (this.totalActivities === 0) this.hasActivityChart = false;
    this.$nextTick(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    });
  }

  slideNext() {
    if (this.swiper) this.swiper.slideNext();
  }

  beforeDestroy() {
    if (this.swiper && this.swiper.destroy) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  formatNumber(number: number) {
    return formatScore(number);
  }

  formatScore(score: number) {
    return formatScore(round(score));
  }

  formatThousands(number: number): number | string {
    if (number > 9999) {
      return `${this.formatNumber(Math.round(number / 1000))}K`;
    }
    return this.formatNumber(number);
  }

  monthName(date: string) {
    return format(new Date(date), 'MMMM');
  }

  shareTwitter() {
    share.twitter(
      `https://profile.codersrank.io/year-in-review-2020/user/${this.$route.params.userHash}/?utm_source=twitter&utm_medium=social&utm_campaign=2020_summary`,
      `Year in Review 2020 - ${this.username}'s Edition`,
    );
  }

  shareFacebook() {
    share.facebook(
      `https://profile.codersrank.io/year-in-review-2020/user/${this.$route.params.userHash}/?utm_source=facebook&utm_medium=social&utm_campaign=2020_summary`,
      `Year in Review 2020 - ${this.username}'s Edition`,
    );
  }

  shareLinkedin() {
    share.linkedin(
      `https://profile.codersrank.io/year-in-review-2020/user/${this.$route.params.userHash}/?utm_source=linkedin&utm_medium=social&utm_campaign=2020_summary`,
      `Year in Review 2020 - ${this.username}'s Edition`,
    );
  }

  shareCopyUrl() {
    copyToClipboard(`https://profile.codersrank.io/year-in-review-2020/user/${this.$route.params.userHash}/`, () => {
      notification({ text: 'URL copied to clipboard' });
    });
  }
}
